import {darkThemeConfig} from 'epic-ue-theme';

const fonts = darkThemeConfig.ue.fonts;

export const theme = {
    fonts
};
